import styled from 'styled-components';

export const ExtraFields = styled.div`
  all: unset;
  max-height: 90px;
  overflow-y: scroll;
  padding: 0.25rem;
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 0rem;
  }
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.light_gray};
    opacity: 0.5;
  }
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
  }
`;
